import { render, staticRenderFns } from "./simNav.vue?vue&type=template&id=3c3a0659&scoped=true"
import script from "./simNav.vue?vue&type=script&lang=js"
export * from "./simNav.vue?vue&type=script&lang=js"
import style0 from "./simNav.vue?vue&type=style&index=0&id=3c3a0659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a0659",
  null
  
)

export default component.exports